if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantInput = this.form.querySelector('[name=id]');
        if (this.variantInput) this.variantInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';

        // Lagerinformationen nur aus bereits eingebetteten Produktdaten lesen.
        // Kein zusaetzlicher Produktseiten-Request beim Klick auf "In den Warenkorb".
        this.stockContext = this.readEmbeddedStockContext();
        this.stockPropertyInput = this.form.querySelector('input[data-candyshop-order-stock]');

        if (this.stockContext && !this.stockPropertyInput) {
          this.stockPropertyInput = document.createElement('input');
          this.stockPropertyInput.type = 'hidden';
          this.stockPropertyInput.name = 'properties[_Bestand]';
          this.stockPropertyInput.dataset.candyshopOrderStock = '1';
          this.form.appendChild(this.stockPropertyInput);
        }

        if (this.variantInput && this.stockContext) {
          this.variantInput.addEventListener('change', () => this.refreshStockProperty());
          this.refreshStockProperty();
        }
      }

      readEmbeddedStockContext() {
        const element = this.querySelector('[data-candyshop-stock-context]');
        if (!element) return null;
        try {
          const context = JSON.parse(element.textContent || '{}');
          return context && Array.isArray(context.variants) ? context : null;
        } catch (error) {
          console.warn('Candyshop Lagerstatus: Produktdaten konnten nicht gelesen werden.', error);
          return null;
        }
      }

      stockLabel(context) {
        if (!context || context.stock <= 0) return '🔴 Kein Bestand';
        if (context.kind === 'own') return `🟢 Eigenlager: ${context.stock} Stück auf Lager`;
        return `🟠 Fremdlager bei den Lieferanten: ${context.stock} Stück`;
      }

      refreshStockProperty() {
        if (!this.stockPropertyInput || !this.variantInput || !this.stockContext || !Array.isArray(this.stockContext.variants)) return false;

        const variantId = String(this.variantInput.value || '');
        const variant = this.stockContext.variants.find((item) => String(item.id || '') === variantId);
        if (!variant || Number.isNaN(Number(variant.stock))) return false;

        this.stockPropertyInput.disabled = false;
        this.stockPropertyInput.name = 'properties[_Bestand]';
        this.stockPropertyInput.value = this.stockLabel({
          stock: Math.max(0, Number(variant.stock)),
          kind: this.stockContext.kind === 'own' ? 'own' : 'supplier',
        });
        return true;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.refreshStockProperty();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              const buttonText = this.submitButton.querySelector('span');
              if (buttonText) buttonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => setTimeout(() => this.cart.renderContents(response)),
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage('Das Produkt konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}
